import React from 'react';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';
import { fg } from '@confluence/feature-gating';

import { BylineContainer, BylineMessageContainer } from './ContentOwnershipStyles';
import { PageOwnershipBylineContent } from './PageOwnershipBylineContent';
import { PageOwnershipBylinePopupHandler } from './PageOwnershipBylinePopupHandler';
import type { UserShape } from './ownership-models';

type PageOwnershipBylineProps = {
	owner: UserShape;
	creator: UserShape;
	createdDate: Date | null;
	templateId: string | null;
	contentId: string | null;
	lastOwner: UserShape | null;
	generatedBy?: string | null;
};
export const PageOwnershipByline = ({
	owner,
	creator,
	createdDate,
	templateId,
	contentId,
	lastOwner,
	generatedBy,
}: PageOwnershipBylineProps) => {
	const isLivePage = useIsCurrentPageLive();

	return (
		<BylineContainer>
			<BylineMessageContainer>
				<PageOwnershipBylineContent
					owner={owner}
					templateId={templateId}
					abbreviateBylineText={isLivePage || fg('cc_page_experiences_new_editor_byline')}
					generatedBy={generatedBy}
				/>
			</BylineMessageContainer>
			{!isLivePage && !fg('cc_page_experiences_new_editor_byline') && (
				<PageOwnershipBylinePopupHandler
					creator={creator}
					createdDate={createdDate}
					ownedByAccountId={owner.userId}
					contentId={contentId}
					lastOwner={lastOwner}
				/>
			)}
		</BylineContainer>
	);
};
